import type { AppDefinition } from '../types';

/** Al Rajhi Bank — direct payout rails. No connector yet. */
export const ALRAJHI_BANK_APP: AppDefinition = {
  id: 'alrajhi-bank',
  nameKey: 'apps.alrajhi-bank.name',
  descriptionKey: 'apps.alrajhi-bank.description',
  logo: '/images/apps/alrajhi-logo.png',
  categories: ['banks'],
  status: 'soon',
  label: 'soon',
};
